export default "__VITE_ASSET__CizNtLb$__"